import { createRoot } from 'react-dom/client';
import Layout from './Layout';

createRoot(app).render(<Layout/>)
